import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-under-maintenance',
  templateUrl: './site-under-maintenance.component.html',
  styleUrls: ['./site-under-maintenance.component.scss']
})
export class SiteUnderMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
